import React from 'react';

interface BadgeProps {
  type: string;
  label: string;
}

const paymentStyles: Record<string, { color: string }> = {
  success: { color: 'bg-green-100 text-green-600' },
  pending: { color: 'bg-yellow-100 text-yellow-600' },
  error: { color: 'bg-red-100 text-red-600' },
};

const Badge: React.FC<BadgeProps> = ({ type, label }) => {
  const { color } = paymentStyles[type] || {
    color: 'bg-gray-100 text-gray-600',
  };

  return (
    <span className={`text-xs px-2 py-1 rounded-md w-fit ${color}`}>
      {label}
    </span>
  );
};

export default Badge;
